import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { App } from '@df/core/app';

let nextUniqueId = 0;

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class FormFieldAbstract implements ControlValueAccessor {
    // tslint:disable-next-line: variable-name
    static ngAcceptInputType_disabled: BooleanInput;
    // tslint:disable-next-line: variable-name
    static ngAcceptInputType_required: BooleanInput;

    protected readonly _uniqueId: string = `form-field-${++nextUniqueId}`;

    protected _disabled = false;
    protected _required = false;
    protected _checked = false;

    text?: string;

    /** A unique id for the checkbox input. If none is supplied, it will be auto-generated. */
    @Input()
    id: string = this._uniqueId;

    /** Name value will be applied to the input element if present */
    @Input()
    name: string | null = null;

    @Input()
    placeholder: string | null = null;

    @Output()
    stateChanges = new EventEmitter<void>();

    /**
     * Whether the checkbox is disabled.
     */
    @Input()
    set disabled(value: any) {
        const newValue = coerceBooleanProperty(value);

        if (newValue !== this.disabled) {
            this._disabled = newValue;
        }
    }
    get disabled() {
        return this._disabled;
    }

    /** Whether the checkbox is required. */
    @Input()
    set required(value: boolean) {
        this._required = coerceBooleanProperty(value);
    }
    get required(): boolean {
        return this._required;
    }

    constructor(
        readonly app: App,
        @Optional() @Self() protected ngControl: NgControl
    ) {
        if (ngControl) {
            // bind the CVA to our control
            ngControl.valueAccessor = this;
        }
    }

    @Input('value')
    get value(): any {
        return this.getValue();
    }
    set value(value: any) {
        this.setValue(value);
    }
    protected _value: any;

    onChange = (_value?: any) => {};
    onTouched = (_value?: any) => {};

    /** Returns the unique id for the visual hidden input. */
    get inputId(): string {
        return `${this.id || this._uniqueId}-input`;
    }

    protected getValue() {
        return this._value;
    }

    protected setValue(value) {
        this._value = value;
    }

    // implementation of `ControlValueAccessor`
    writeValue(value: any): void {
        this.value = value;

        if (typeof value === 'string') {
            this.text = value;
        }

        this.onChange(this.value);
        this.stateChanges.emit(this.value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }
}
